import React from "react";
class ActiveTaskItem extends React.Component {
	constructor(props) {
		super(props);
		var now = new Date();
		if(this.props.item.taskDetails.reminder!=null 
		&& this.props.item.taskDetails.reminder.time!=null){
			var reminderTime = new Date(this.props.item.taskDetails.reminder.time);
			if(reminderTime.getFullYear()=== now.getFullYear()
			&& reminderTime.getDate()=== now.getDate()
			&& reminderTime.getMonth()=== now.getMonth())

			this.state={class:"todaysreminder"};
		else if (reminderTime<now){
			this.state={class:"passedoutreminder"};
		}else
		this.state={class:"scheduled"};
		}
		else
		this.state={class:"scheduled"};
	}
	render() {
		return <tr className={this.state.class} ><td>{this.props.item.id}</td><td>{this.props.item.taskDetails.name}</td><td><button onClick={this.props.toggleDetails}>Toggle Details</button> </td></tr>
	}
}

export default ActiveTaskItem;